// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__BlGLi","unreadBadge":"styles_unreadBadge__EIRvn","modalContent":"styles_modalContent__2nLmM","modal":"styles_modal__nBtB-"};